export default { 
  typesTrade: []
}